import { SHARED_VALUE } from "@koru/shared";
import { useEffect } from "react";

import { CookieConsent } from "./components/CookieConsent";
import Router from "./components/Router";
import {
  checkAndTrackReturnUser,
  initializeAnalyticsWithConsent,
} from "./utils/analytics";

export default function App() {
  // Initialize analytics on app start - only if user has consented
  // If no consent, CookieConsent component will handle initialization after consent is granted
  useEffect(() => {
    try {
      console.log("Shared Value:", SHARED_VALUE);
      // Only initialize if user has already consented
      const hasConsented = initializeAnalyticsWithConsent();
      if (hasConsented) {
        // Check and track if this is a returning user
        checkAndTrackReturnUser();
      }
    } catch (error) {
      console.error("Analytics initialization error:", error);
    }
  }, []);

  return (
    <>
      <Router />
      <CookieConsent />
    </>
  );
}
